import { graphqlRequest, hasGraphQLErrors, hasGraphQLNetworkError } from '~/adapters/graphqlRequest';
import { GetSurveyTypeAttributesDocument } from '~/gql/graphql';

export interface FetchEmployeeAttributesQuery {
  companyId: number;
  surveyTypeId: number;
  includePrivateAttributes: boolean;
}

// Naming this as fetchEmployeeAttributes because fetchSurveyTypeAttributes name is completely misleading
// There are no survey type attributes. Just employee attributes that can be hidden/visible depending
// on the user permission for that survey type.
const fetchEmployeeAttributes = async (query: FetchEmployeeAttributesQuery) => {
  try {
    const res = await graphqlRequest<any>(GetSurveyTypeAttributesDocument, {
      companyId: query.companyId,
      surveyTypeId: query.surveyTypeId,
      includePrivateAttributes: query.includePrivateAttributes,
    });

    if (hasGraphQLNetworkError(res)) return Promise.reject(res.error);
    if (hasGraphQLErrors(res)) return Promise.reject(res.errors[0]);

    return res.data?.surveyTypeAttributes;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const attributesQueries = {
  fetchEmployeeAttributes,
};
